import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ChildPriceDropdown,
  CopyToOtherUser,
  CreateClientPrice,
  CustomerPriceListing,
  DeleteClientPriceList,
  GetLanguages,
  GetOneClientPrice,
  JobSummeryResource,
  MasterPriceListDropdown,
  SpecializationDropdown,
  UpdateClientPrice,
} from "../../../../redux/Thunk/ClientModule/ClientThunk";
import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Btn from "../../../../Components/Ui_elements/Btn";
import TextFieldComponent from "../../../../Components/TextFieldComponent";
import DropdownComponent from "../../../../Components/DropdownComponent";
import { CurrencyCode } from "../../../../redux/Thunk/AdminModule/AdminThunk";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useParams } from "react-router-dom";
import GenericTable from "../../../../Components/Ui_elements/GenericTable";
import { SortAlphabetically } from "../../../../Helper/SortAlphbetically";
import PopupModal from "../../../../Components/Ui_elements/PopupModal";
import { getSingleExternalResource } from "../../../../redux/Thunk/externalResourceThunk";
import {
  commaToDot,
  formatUtcDateTimeToLocal,
  isValidNumber,
  localizeNumber,
} from "../../../../Helper/generalhelper";
import MultiSelect from "../../../../Components/MultiSelect";
import DropdownWithSelectedList from "../../../../Components/DropdownWithSelectedList";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import authApi from "../../../../redux/authApi";
import { showSnackbar } from "../../../../redux/Slice/snackbar/snackbarSlice";

const Step3 = ({ registerSubmit, resourceIdOverride }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cId = searchParams.get("c_id");
  const deepLinkedPriceListId = Number(searchParams.get("price_list_id") || 0);
  const { user: loginUser } = useSelector(state => state.root.authUser);
  const isLinguistSelf = loginUser?.iFkUserTypeId === 2;

  const {
    specialization_list,
    master_price_list,
    child_price_list,
    languages_dropdown_list,
    customer_price_list,
    single_price_data,
    job_summery_resource,
  } = useSelector(state => state.root.ClientModule);
  const { currencyCode } = useSelector(state => state.root.AdminModule);
  const { externalResource, new_external_created, edit_external_resource_data } = useSelector(
    state => state.root.ExternalResource
  );

  const resolvedResourceId = resourceIdOverride || id || new_external_created?.iUserId;

  const externalResourceArray = [externalResource];
  const filteredArray = externalResourceArray?.filter(item => item !== null); // Remove null values

  const userName = filteredArray?.find(item => item?.iUserId == resolvedResourceId)
    ? `${filteredArray.find(item => item?.iUserId == resolvedResourceId)?.vFirstName || ""} ${filteredArray.find(item => item?.iUserId == resolvedResourceId)?.vLastName || ""}`.trim()
    : new_external_created?.userData
      ? `${new_external_created.userData?.vFirstName || ""} ${new_external_created.userData?.vLastName || ""}`.trim()
      : edit_external_resource_data?.data
        ? `${edit_external_resource_data.data?.vFirstName || ""} ${edit_external_resource_data.data?.vLastName || ""}`.trim()
        : "";

  const freelancerCurrencyCode = filteredArray?.find(item => item?.iUserId == resolvedResourceId)?.currency_code ?? "EUR";

  const [linguistPriceList, setLinguistPriceList] = useState(null);
  const [linguistPriceLists, setLinguistPriceLists] = useState([]);
  const [linguistRequestBatches, setLinguistRequestBatches] = useState([]);
  const [selectedBatchRequest, setSelectedBatchRequest] = useState(null);
  const makePriceRowKey = (basePriceUnit, masterPriceId, childPriceId) =>
    `${basePriceUnit}|${masterPriceId ?? ""}|${childPriceId ?? ""}`;

  const parseStoredJsonArray = (value, fallback = []) => {
    if (!value) return fallback;
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : fallback;
      } catch {
        return fallback;
      }
    }
    return fallback;
  };

  const buildFormStateFromPriceList = (priceData, currencyCode) => {
    if (!priceData) {
      return {
        formData: null,
        languageRows: [],
        languageRowsShort: [],
        priceRows: [],
      };
    }

    const {
      price_name,
      min_price_item,
      specialization,
      price_language,
      price_basis,
    } = priceData;

    const parsedPriceLanguage = parseStoredJsonArray(price_language);
    const parsedPriceBasis = parseStoredJsonArray(price_basis);

    const nextLanguageRows = parsedPriceLanguage.map(lang => lang.languagePrice);
    const nextLanguageRowsShort = nextLanguageRows.map(lang => {
      const [source, target] = lang.split(" > ");
      return `${source?.substring(0, 3).toUpperCase()} > ${target
        ?.substring(0, 3)
        .toUpperCase()}`;
    });

    const nextPriceRows = parsedPriceBasis.map(price => {
      const total =
        (Number(commaToDot(price.baseQuentity)) || 0) *
        (Number(commaToDot(price.basePrice)) || 0);

      return {
        quantity: localizeNumber(price.baseQuentity),
        priceUnit: price.basePriceUnit,
        prices: localizeNumber(price.basePrice, 4),
        weighting: 1.0,
        total: localizeNumber(total, 4),
        childPriceId: price.childPriceId,
        masterPriceId: price.masterPriceId,
      };
    });

    return {
      formData: {
        price_name,
        price_currency: currencyCode,
        min_price_item,
        specialization: specialization ? specialization.split(",") : [],
        source_lang: "",
        target_lang: "",
        basePriceType: "",
      },
      languageRows: nextLanguageRows,
      languageRowsShort: nextLanguageRowsShort,
      priceRows: nextPriceRows,
    };
  };

  const buildLinguistEffectivePriceData = (selected, pendingBatch) => {
    if (!selected) return null;
    if (!pendingBatch) return selected;
    return {
      ...selected,
      price_language:
        pendingBatch?.requested_price_language ?? selected?.price_language,
      price_basis: pendingBatch?.requested_price_basis ?? selected?.price_basis,
    };
  };

  const [show, setShow] = useState(false);
  const [languageRows, setLanguageRows] = useState([]);
  const [languageRowsShort, setLanguageRowsShort] = useState([]);
  const [priceRows, setPriceRows] = useState([]);
  const [selectedPrices, setSelectedPrices] = useState([]);
  const [openForDelete, setOpenForDelete] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [edit, setEdit] = useState(false);
  const priceRowsRef = useRef(priceRows);
  const autoOpenedPriceListIdRef = useRef(null);

  const [formData, setFormData] = useState({
    price_name: `${userName} | `,
    price_currency: "",
    min_price_item: "",
    specialization: [],
    source_lang: "",
    target_lang: "",
    basePriceType: "",
  });
  const [copyToClient, setCopyToClient] = useState({
    client_id: "",
  });
  useEffect(() => {
    priceRowsRef.current = priceRows;
  }, [priceRows]);

  const loadFormFromPriceListData = priceData => {
    if (!priceData || !freelancerCurrencyCode) return;

    const {
      formData: nextFormData,
      languageRows: nextLanguageRows,
      languageRowsShort: nextLanguageRowsShort,
      priceRows: nextPriceRows,
    } = buildFormStateFromPriceList(priceData, freelancerCurrencyCode);

    if (!nextFormData) return;

    setFormData(nextFormData);
    setLanguageRows(nextLanguageRows);
    setLanguageRowsShort(nextLanguageRowsShort);
    setPriceRows(nextPriceRows);
    priceRowsRef.current = nextPriceRows;
  };

  const applyLinguistPriceListSelection = (
    selected,
    { openEditor = true } = {},
    requestBatchesOverride = linguistRequestBatches
  ) => {
    if (!selected) return;

    const pendingBatch = (requestBatchesOverride || []).find(
      request =>
        Number(request?.price_list_id) === Number(selected?.price_list_id) &&
        request?.status === "pending"
    );

    const isSwitchingList =
      Number(linguistPriceList?.price_list_id) !== Number(selected?.price_list_id);

    setLinguistPriceList(selected);
    setSelectedBatchRequest(pendingBatch || null);

    if (isSwitchingList) {
      setSelectedPrices([]);
      setError({});
    }

    if (openEditor) {
      setShow(true);
      setEdit(true);
      loadFormFromPriceListData(
        buildLinguistEffectivePriceData(selected, pendingBatch)
      );
    }
  };

  const refreshLinguistRates = (options = {}) => {
    const { openLatest = false } = options;
    return authApi.get(`/linguist/price-list-drafts`).then(res => {
      const payload = res?.data?.data;
      const priceLists = payload?.priceLists || [];
      const requestBatches = payload?.requestBatches || [];
      setLinguistPriceLists(Array.isArray(priceLists) ? priceLists : []);
      setLinguistRequestBatches(Array.isArray(requestBatches) ? requestBatches : []);
      if (openLatest) {
        const latest = priceLists.length > 0 ? priceLists[0] : null;
        if (latest) {
          applyLinguistPriceListSelection(latest, { openEditor: true }, requestBatches);
        }
      }
      return { priceLists, requestBatches };
    });
  };

  useEffect(() => {
    if (resolvedResourceId && !isLinguistSelf) {
      dispatch(getSingleExternalResource({ user_id: resolvedResourceId }));
    }
    dispatch(SpecializationDropdown());
    dispatch(MasterPriceListDropdown());
    dispatch(ChildPriceDropdown());
    dispatch(GetLanguages());
    dispatch(CurrencyCode());
    dispatch(CustomerPriceListing(2));
    dispatch(JobSummeryResource());

    if (isLinguistSelf) {
      refreshLinguistRates().catch(() => {});
    }
  }, [dispatch]);

  useEffect(() => {
    if (!isLinguistSelf || !linguistPriceList?.price_list_id) return;
    const pendingBatch = (linguistRequestBatches || []).find(
      request =>
        Number(request?.price_list_id) === Number(linguistPriceList?.price_list_id) &&
        request?.status === "pending"
    );
    setSelectedBatchRequest(pendingBatch || null);
  }, [isLinguistSelf, linguistPriceList, linguistRequestBatches]);

  useEffect(() => {
    if (userName && !edit) {
      // Only update if not in edit mode
      setFormData(prevData => ({
        ...prevData,
        price_name: `${userName} | `,
      }));
    }
  }, [userName, edit]);

  useEffect(() => {
    if (!deepLinkedPriceListId) {
      autoOpenedPriceListIdRef.current = null;
      return;
    }

    if (autoOpenedPriceListIdRef.current === deepLinkedPriceListId) {
      return;
    }

    if (isLinguistSelf) {
      const selectedPriceList = (linguistPriceLists || []).find(
        pl => Number(pl?.price_list_id) === deepLinkedPriceListId
      );

      if (!selectedPriceList) {
        return;
      }

      applyLinguistPriceListSelection(selectedPriceList, { openEditor: true });
      setEdited(true);
      autoOpenedPriceListIdRef.current = deepLinkedPriceListId;
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const selectedPriceList = (customer_price_list || []).find(
      item =>
        Number(item?.price_list_id) === deepLinkedPriceListId &&
        Number(item?.resource_id) === Number(resolvedResourceId || cId)
    );

    if (!selectedPriceList) {
      return;
    }

    dispatch(GetOneClientPrice(deepLinkedPriceListId));
    setEdited(true);
    setShow(true);
    setEdit(true);
    autoOpenedPriceListIdRef.current = deepLinkedPriceListId;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [
    cId,
    customer_price_list,
    deepLinkedPriceListId,
    dispatch,
    isLinguistSelf,
    linguistPriceLists,
    resolvedResourceId,
  ]);

  const effectiveSinglePriceData = useMemo(() => {
    if (!isLinguistSelf) {
      return single_price_data;
    }

    if (!selectedBatchRequest) {
      return linguistPriceList;
    }

    return {
      ...(linguistPriceList || {}),
      price_language: selectedBatchRequest?.requested_price_language,
      price_basis: selectedBatchRequest?.requested_price_basis,
    };
  }, [
    isLinguistSelf,
    single_price_data,
    linguistPriceList,
    selectedBatchRequest?.requested_price_language,
    selectedBatchRequest?.requested_price_basis,
  ]);

  const isLinguistRequestLocked = isLinguistSelf && selectedBatchRequest?.status === "pending";

  useEffect(() => {
    if (!effectiveSinglePriceData || !edit || !freelancerCurrencyCode) return;
    if (isLinguistSelf) return;
    loadFormFromPriceListData(effectiveSinglePriceData);
  }, [effectiveSinglePriceData, edit, freelancerCurrencyCode, isLinguistSelf]);

  useEffect(() => {
    if (!isLinguistSelf || !edit || !linguistPriceList || !freelancerCurrencyCode) return;
    loadFormFromPriceListData(effectiveSinglePriceData);
  }, [
    isLinguistSelf,
    edit,
    linguistPriceList?.price_list_id,
    selectedBatchRequest?.price_list_id,
    selectedBatchRequest?.requested_price_language,
    selectedBatchRequest?.requested_price_basis,
    freelancerCurrencyCode,
    effectiveSinglePriceData,
  ]);


  const sourceLangCode = formData.source_lang?.substring(0, 3).toUpperCase() || "";
  const targetLangCode = formData.target_lang?.substring(0, 3).toUpperCase() || "";

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));

    setCopyToClient(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeLanguage = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleChange = (event, newValue) => {
    const selectedMasterIds = newValue
      .filter(item => item.type === "master")
      .map(item => item.master_price_id);

    const updatedSelection = newValue.flatMap(item => {
      if (item.type === "master") {
        return [
          item,
          ...child_price_list.filter(child => child.master_price_id === item.master_price_id),
        ];
      }
      return item;
    });

    const filteredSelection = updatedSelection.filter(item => {
      if (item.type === "child") {
        return selectedMasterIds.includes(item.master_price_id);
      }
      return true;
    });

    setSelectedPrices(filteredSelection);
  };

  const handleAddLanguageRow = () => {
    if (isLinguistRequestLocked) return;
    if (!formData.source_lang?.trim()) {
      setError(prev => ({
        ...prev,
        source_lang: "Source language is required",
      }));
    }
    if (!formData.target_lang?.trim()) {
      setError(prev => ({
        ...prev,
        target_lang: "Target language is required",
      }));
    }
    if (!formData.source_lang || !formData.target_lang) return;

    const newLanguagePair = `${formData.source_lang} > ${formData.target_lang}`;
    const newLanguagePairShort = `${sourceLangCode} > ${targetLangCode}`;
    if (languageRows.includes(newLanguagePair)) {
      setError(prev => ({
        ...prev,
        languageRows: "This language pair is already added",
      }));
      return;
    }

    setLanguageRowsShort(prev => [...prev, newLanguagePairShort]);
    setLanguageRows(prev => [...prev, newLanguagePair]);

    // Fix: Only add language pairs if there are any
    const languagePart =
      [...languageRowsShort, newLanguagePairShort].length > 0
        ? ` | ${[...languageRowsShort, newLanguagePairShort].join(" | ")} |`
        : "";

    setFormData(prevData => ({
      ...prevData,
      price_name: `${prevData.price_name.split("|")[0].trim()}${languagePart}`,
    }));

    setFormData(prevData => ({
      ...prevData,
      source_lang: "",
      target_lang: "",
    }));

    setError(prev => {
      const newErr = { ...prev };
      delete newErr.languageRows;
      return newErr;
    });
  };

  const handleAddPriceRow = () => {
    if (isLinguistRequestLocked) return;
    if (selectedPrices.length === 0) {
      setError(prev => ({
        ...prev,
        selectedPrices: "Please select at least one price",
      }));
      return;
    }
    const newRows = selectedPrices
      .filter(selectedPrice => {
        const selectedKey = makePriceRowKey(
          selectedPrice.name,
          selectedPrice.master_price_id,
          selectedPrice.child_price_id
        );
        return !priceRows.some(row =>
          makePriceRowKey(row.priceUnit, row.masterPriceId, row.childPriceId) === selectedKey
        );
      })
      .map(selectedPrice => ({
        quantity: 1, // Default quantity
        priceUnit: selectedPrice.name, // Use the selected price name
        prices: 1.0, // Default price
        weighting: 1.0, // Default weighting
        total: 1.0, // Default total
        childPriceId: selectedPrice.child_price_id,
        masterPriceId: selectedPrice.master_price_id,
      }));

    setPriceRows(prev => [...prev, ...newRows]);
    setSelectedPrices([]); // Clear the selected prices after adding rows

    setError(prev => {
      const newErr = { ...prev };
      delete newErr.priceRows;
      return newErr;
    });
  };

  const handleMultiSelectChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
    if (value && (typeof value === "string" ? value.trim() : value.length > 0)) {
      setError(prev => {
        const newErr = { ...prev };
        delete newErr[name];
        return newErr;
      });
    }
  };

  const handleChipDelete = valueToRemove => {
    setFormData(prev => ({
      ...prev,
      specialization: prev.specialization.filter(item => item !== valueToRemove),
    }));
  };

  const handleDelete = index => {
    if (isLinguistRequestLocked) return;
    const updatedLanguageRows = languageRows.filter((_, i) => i !== index);
    setLanguageRows(updatedLanguageRows);
    const updatedLanguageRowsShort = languageRowsShort.filter((_, i) => i !== index);
    setLanguageRowsShort(updatedLanguageRowsShort);

    // Fix: Only add language pairs if there are any
    const languagePart =
      updatedLanguageRowsShort.length > 0 ? ` | ${updatedLanguageRowsShort.join(" | ")} |` : "";

    setFormData(prevData => ({
      ...prevData,
      price_name: `${prevData.price_name.split("|")[0].trim()}${languagePart}`,
    }));
  };

  const handleDeletePriceRow = index => {
    if (isLinguistRequestLocked) return;
    const updatedPriceRows = priceRows.filter((_, i) => i !== index);
    setPriceRows(updatedPriceRows);
  };

  const handleQuantityChange = (index, value) => {
    if (isLinguistRequestLocked) return;
    const updatedPriceRows = [...priceRows];
    const total =
      (Number(commaToDot(value)) || 0) *
      (Number(commaToDot(updatedPriceRows[index].prices)) || 0);

    updatedPriceRows[index].quantity = value;
    updatedPriceRows[index].total = localizeNumber(total, 4);
    setPriceRows(updatedPriceRows);
  };

  const handlePriceChange = (index, value) => {
    if (isLinguistRequestLocked) return;
    const updatedPriceRows = [...priceRows];
    const total =
      (Number(commaToDot(value)) || 0) *
      (Number(commaToDot(updatedPriceRows[index].quantity)) || 0);

    updatedPriceRows[index].prices = value;
    updatedPriceRows[index].total = localizeNumber(total, 4);
    setPriceRows(updatedPriceRows);
  };
  const [edited, setEdited] = useState(false);
  const [error, setError] = useState({});
  const handleSave = () => {
    setShow(true);
    setEdited(false);
    const newErrors = {};

    if (!formData.price_name?.trim()) {
      newErrors.price_name = "Name is required";
    }
    if (!formData.specialization?.length) {
      newErrors.specialization = "Specialization is required";
    }

    if (!formData.price_currency?.trim()) {
      newErrors.price_currency = "Currency is required";
    }

    // if (!formData.min_price_item?.toString().trim()) {
    //   newErrors.min_price_item = "Min price item is required";
    // }

    if (languageRows.length === 0) {
      newErrors.languageRows = "At least one language pair is required";
    }

    if (priceRows.length === 0) {
      newErrors.priceRows = "At least one price is required";
    }

    setError(prevError => ({
      ...prevError,
      ...newErrors,
    }));

    if (Object.keys(newErrors).length > 0) {
      return; // stop here if there are validation errors
    }

    const priceBasisArray = priceRows.map(row => ({
      baseQuentity: commaToDot(row.quantity),
      basePricecheck: 1,
      basePriceUnit: row.priceUnit,
      basePrice: commaToDot(row.prices),
      standardTime: "",
      childPriceId: row.childPriceId,
      masterPriceId: row.masterPriceId,
    }));

    const payload = {
      price_name: formData.price_name,
      //price_currency: `${formData.price_currency},${currencyCode[formData.price_currency]?.symbol}`,
      price_currency: `${formData.price_currency},${currencyCode[formData.price_currency]?.symbol}`,
      min_price_item: formData.min_price_item,
      specialization: formData.specialization.join(","),
      price_language: JSON.stringify(languageRows.map(lang => ({ languagePrice: lang }))),
      price_basis: JSON.stringify(priceBasisArray), // Use the properly constructed array
      price_id: 2, // 1 static for the client and 2 for resource
      resource_id: resolvedResourceId, // freelancer resource id
    };

    // Add price_list_id only if it's an edit operation
    if (edit && effectiveSinglePriceData?.price_list_id) {
      payload.price_list_id = effectiveSinglePriceData.price_list_id;
    }

    if (isLinguistSelf) {
      const priceListId = effectiveSinglePriceData?.price_list_id;
      if (!priceListId) {
        dispatch(
          showSnackbar({
            message: "No price list found to submit changes.",
            type: "error",
          })
        );
        return false;
      }

      if (isLinguistRequestLocked) {
        dispatch(
          showSnackbar({
            message: "A request for this price list is already pending review.",
            type: "info",
          })
        );
        return true;
      }

      const requestPayload = {
        price_list_id: priceListId,
        base_modified_date: linguistPriceList?.modified_date || effectiveSinglePriceData?.modified_date,
        price_language: languageRows.map(lang => ({ languagePrice: lang })),
        price_basis: priceBasisArray,
      };

      authApi
        .post(`/linguist/price-list-draft-requests`, requestPayload)
        .then(res => {
          dispatch(
            showSnackbar({
              message: res?.data?.msg || "Submitted for approval.",
              type: "success",
            })
          );
          const currentPriceListId = effectiveSinglePriceData?.price_list_id;
          return refreshLinguistRates().then(({ priceLists, requestBatches }) => {
            if (currentPriceListId) {
              const selected = priceLists.find(
                pl => Number(pl.price_list_id) === Number(currentPriceListId)
              );
              if (selected) {
                applyLinguistPriceListSelection(selected, { openEditor: true }, requestBatches);
              }
            }
          });
        })
        .catch(err => {
          dispatch(
            showSnackbar({
              message: err?.response?.data?.msg || "Failed to submit requests.",
              type: "error",
            })
          );
        });

      return true;
    }

    const action = edit ? UpdateClientPrice : CreateClientPrice;

    dispatch(action(payload)).then(() => {
      dispatch(CustomerPriceListing(2));
      setShow(false);

      // Reset form data but keep the username in the price_name field
      setFormData({
        price_name: `${userName} | `, // Preserve the username
        price_currency: "",
        min_price_item: "",
        specialization: [],
        source_lang: "",
        target_lang: "",
        basePriceType: "",
      });
      setError({});
      setLanguageRows([]);
      setLanguageRowsShort([]);
      setPriceRows([]);
      setEdit(false);
    });
    return true;
  };

  const options = master_price_list?.flatMap(master => [
    { type: "master", ...master },
    ...child_price_list.filter(child => child?.master_price_id === master?.master_price_id),
  ]);

  const currencyOptions = Object.entries(currencyCode)?.map(([key, currency]) => ({
    label: `${key}`,
    value: key,
  }));

  const specializationOptions = specialization_list?.map(item => ({
    label: item.name,
    value: item.id,
  }));

  const languageOptions = languages_dropdown_list?.map(item => ({
    label: item.title,
    value: item.title,
  }));

  const jobResourceOptions = job_summery_resource?.map(resource => ({
    value: resource.iUserId,
    label: resource?.fullName?.trim() || resource?.vUserName,
  }));
  const resourceId = resolvedResourceId || id || cId;
  const TableList = isLinguistSelf
    ? linguistPriceLists
    : customer_price_list?.filter(item => item?.resource_id == resourceId);

  const columns = [
    {
      name: "rowNumber",
      label: "No.",
      options: {
        sort: true,
        setCellHeaderProps: () => ({ style: { width: "50px" } }),
        setCellProps: () => ({ style: { width: "40px" } }),
      },
    },
    { name: "price_list_id", label: "ID", options: { display: false } },
    {
      name: "price_name",
      label: "Name",
      options: {
        setCellHeaderProps: () => ({ style: { width: "200px" } }),
        setCellProps: () => ({ style: { width: "200px" } }),
      },
    },
    // {
    //   name: "price_basis",
    //   label: "New Word Rate",
    //   options: {
    //     filter: false,
    //     customBodyRender: value =>
    //       getRateFromPriceBasis(value, "Words Translation (New)"),
    //   },
    // },
    // {
    //   name: "price_basis",
    //   label: "Hourly Proofreading Rate",
    //   options: {
    //     filter: false,
    //     customBodyRender: value =>
    //       getRateFromPriceBasis(value, "Hour(s) Proofreading"),
    //   },
    // },
    // {
    //   name: "price_basis",
    //   label: "Machine Translation Rate",
    //   options: {
    //     filter: false,
    //     customBodyRender: value =>
    //       getRateFromPriceBasis(value, "Machine Translation Editing (New)"),
    //   },
    // },
    ...(!isLinguistSelf
      ? [
          {
            name: "price_list_id",
            label: "Copy Price",
            options: {
              sort: false,
              setCellHeaderProps: () => ({ style: { width: "200px" } }),
              setCellProps: () => ({ style: { width: "200px" } }),
              customBodyRender: value => (
                <div
                  onClick={() => handleButtonClick(value)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    color: "#1976d2",
                  }}
                >
                  <ContentCopyIcon style={{ marginRight: 6 }} />
                  Copy price list
                </div>
              ),
            },
          },
        ]
      : []),
  ];

  const sortedData = SortAlphabetically(TableList || [], "price_name");
  const data = sortedData?.map((item, index) => ({
    rowNumber: index + 1,
    price_list_id: item.price_list_id,
    price_name: item.price_name,
  }));

  const handleEdit = rowData => {
    const selectedId = Number(rowData[1]);
    if (isLinguistSelf) {
      const selected = (linguistPriceLists || []).find(
        pl => Number(pl.price_list_id) === selectedId
      );
      if (!selected) {
        dispatch(
          showSnackbar({
            message: "Price list not found.",
            type: "error",
          })
        );
        return;
      }
      applyLinguistPriceListSelection(selected);
      setEdited(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    dispatch(GetOneClientPrice(selectedId));
    setEdited(true);
    setShow(true);
    setEdit(true);
  };

  const handleDeleteTable = id => {
    setOpenForDelete(true);
    setDeleteId(id);
  };
  const [selectedPriceId, setSelectedPriceId] = useState(null);

  const handleButtonClick = clickedId => {
    setSelectedPriceId(clickedId);
    setCopyOpen(true);
    setCopyToClient({});
  };

  const handleCopyPrice = () => {
    const payload = {
      price_list_id: selectedPriceId,
      externalUserClient: copyToClient.client_id,
      typeId: 2, // for freelancer resource 2 will be passed as static
    };
    dispatch(CopyToOtherUser(payload)).then(() => {
      setCopyOpen(false);
      setCopyToClient({});
    });
  };

  useEffect(() => {
    if (isLinguistSelf) {
      registerSubmit(() => true);
    } else {
      registerSubmit(handleSave);
    }
  }, [formData, isLinguistSelf]);

  useEffect(() => {
    if (freelancerCurrencyCode && !edit) {
      setFormData(prev => ({
        ...prev,
        price_currency: freelancerCurrencyCode,
      }));
    }
  }, [freelancerCurrencyCode, edit]);


  return (
    <Box sx={{ background: "#f4f4fb" }}>
      {show && (
        <Box sx={{ p: 1, mb: 4, borderRadius: 2 }} className="whiteBackground">
          {isLinguistSelf && (
            <Box
              sx={{
                mb: 2,
                p: 2,
                border: "1px solid #d7d7e0",
                borderRadius: 2,
                backgroundColor: isLinguistRequestLocked ? "#fff8e1" : "#f7f7fb",
              }}
            >
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {isLinguistRequestLocked
                  ? "A draft request for this price list is pending approval."
                  : "Only language pairs, pricing rows, quantities, and rates are submitted for approval."}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {isLinguistRequestLocked
                  ? `The requested draft is shown below in read-only mode${
                      selectedBatchRequest?.created_at
                        ? ` (submitted ${formatUtcDateTimeToLocal(selectedBatchRequest.created_at)}).`
                        : "."
                    }`
                  : "Name, currency, minimum charge, and specialization stay read-only in self-service mode."}
              </Typography>
              {selectedBatchRequest?.summary && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Changed rows: {selectedBatchRequest.summary.changedRowsCount || 0} | Added
                  language pairs: {selectedBatchRequest.summary.addedLanguagePairsCount || 0} |
                  Added services: {selectedBatchRequest.summary.addedServicesCount || 0}
                </Typography>
              )}
            </Box>
          )}
          <Grid container justifyContent="space-between" alignItems="flex-start">
            {/* Left Box - New Price List (Fixed Height) */}
            {/* <Grid item className="boxshadow" width="40%" p={2} sx={{ height: "150px" }}>
              <Typography variant="subtitle1">New price list</Typography>
              <Grid container justifyContent="space-between" alignItems="center" mt={1}>
                <Typography variant="subtitle1">Create new price list</Typography>
                <Btn onClick={() => setShow(prev => !prev)} disabled={edited === true}>
                  Create
                </Btn>
              </Grid>
            </Grid> */}

            {/* Right Box - Form Input (Flexible Height) */}
            {show && (
              <Grid item className="boxshadow" md={6} p={2} sx={{ height: "auto" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <TextFieldComponent
                      type="text"
                      name="price_name"
                      label="Name"
                      value={formData.price_name}
                      onChange={handleInputChange}
                      error={error.price_name}
                      disabled={isLinguistSelf}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <DropdownComponent
                      label="Currency Code"
                      name="price_currency"
                      value={formData.price_currency}
                      onChange={handleInputChange}
                      options={currencyOptions}
                      error={error.price_currency}
                      disabled={isLinguistSelf}
                      searchable={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextFieldComponent
                      type="text"
                      name="min_price_item"
                      label="Minimum Charge"
                      value={formData.min_price_item}
                      error={error.min_price_item}
                      onChange={handleInputChange}
                      isNotMandatory={true}
                      disabled={isLinguistSelf}
                      onlyNumber
                      fullWidth
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={12}>
                    <MultiSelect
                    label="Specialization"
                    name="specialization"
                    value={formData.specialization || []}
                    onChange={(e, name) => handleMultiSelectChange(e, name)}
                    handleChipDelete={handleChipDelete}
                    options={specializationOptions}
                  />
                  </Grid> */}
                </Grid>
              </Grid>
            )}

            {/* Languages Table */}
            {show && (
              <Grid item xs={12} md={6}>
                <DropdownWithSelectedList
                  label="Specialization"
                  name="specialization"
                  value={formData.specialization || []}
                  onChange={handleMultiSelectChange}
                  options={specializationOptions}
                  error={error.specialization}
                  disabled={isLinguistSelf}
                  required
                />
              </Grid>
            )}
          </Grid>

          {show && (
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    width: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    Languages
                  </Typography>
                  {error.languageRows && (
                    <Typography color="error" variant="caption" display="block" sx={{ mb: 1 }}>
                      {error.languageRows}
                    </Typography>
                  )}

                  <Table sx={{ borderBottom: "1px solid #ddd" }}>
                    <TableHead>
                      <TableRow sx={{ background: "#f8f8f8" }}>
                        <TableCell sx={{ fontWeight: "bold" }}>Languages</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {languageRows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row}</TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => handleDelete(index)}
                              color="error"
                              disabled={isLinguistRequestLocked}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {/* Form to Add New Language Rows */}
                  <Box sx={{ mt: 3 }}>
                    <Grid container alignItems="center" spacing={3}>
                      <Grid item xs={12} container alignItems="center">
                        <Typography variant="body2" sx={{ width: "100%" }}>
                          Add Language Pair
                        </Typography>

                        {/* Source Language */}
                        <Grid item xs={4.5} p={0}>
                          <DropdownComponent
                            label="Source Language"
                            name="source_lang"
                            value={formData.source_lang}
                            onChange={e => handleChangeLanguage("source_lang", e.target.value)}
                            error={error.source_lang}
                            options={languageOptions}
                            disabled={isLinguistRequestLocked}
                          />
                        </Grid>

                        {/* Target Language */}
                        <Grid item xs={4.5} p={2}>
                          <DropdownComponent
                            label="Target Language"
                            name="target_lang"
                            value={formData.target_lang}
                            error={error.target_lang}
                            onChange={e => handleChangeLanguage("target_lang", e.target.value)}
                            options={languageOptions}
                            disabled={isLinguistRequestLocked}
                          />
                        </Grid>

                        {/* ✔ Button */}
                        <Grid item xs={2} mt={3} p={3}>
                          <Btn onClick={handleAddLanguageRow} disabled={isLinguistRequestLocked}>
                            ✔
                          </Btn>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
              {/* Prices Table */}
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    width: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    Prices
                  </Typography>
                  {error.priceRows && (
                    <Typography color="error" variant="caption" display="block" sx={{ mb: 1 }}>
                      {error.priceRows}
                    </Typography>
                  )}

                  <Table sx={{ width: "100%", borderBottom: "1px solid #ddd" }}>
                    <TableHead>
                      <TableRow sx={{ background: "#f8f8f8" }}>
                        <TableCell sx={{ fontWeight: "bold" }}>Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Price unit</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Prices</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {priceRows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              type="text"
                              value={row.quantity}
                              disabled={isLinguistRequestLocked}
                              onChange={e =>
                                isValidNumber(e.target.value) &&
                                handleQuantityChange(index, e.target.value)
                              }
                              fullWidth
                            />
                          </TableCell>
                          <TableCell>{row.priceUnit}</TableCell>
                          <TableCell>
                            <TextField
                              type="text"
                              value={row.prices}
                              disabled={isLinguistRequestLocked}
                              onChange={e =>
                                isValidNumber(e.target.value) &&
                                handlePriceChange(index, e.target.value)
                              }
                              fullWidth
                            />
                          </TableCell>
                          <TableCell>{row.total} {freelancerCurrencyCode}</TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => handleDeletePriceRow(index)}
                              color="error"
                              disabled={isLinguistRequestLocked}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {/* Form to Add New Price Rows */}
                  <Box sx={{ mt: 3 }}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid
                        item
                        xs={12}
                        container
                        alignItems="center"
                        // spacing={2}
                        wrap="nowrap"
                      >
                        <Typography variant="body2" sx={{ width: "100%" }}>
                          Add Price Details
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Autocomplete
                          multiple
                          disabled={isLinguistRequestLocked}
                          options={options}
                          groupBy={option => (option.type === "master" ? option.name : "")}
                          getOptionLabel={option => option.name}
                          value={selectedPrices}
                          onChange={handleChange}
                          disableCloseOnSelect
                          renderInput={params => (
                            <TextField
                              {...params}
                              //   variant="outlined"
                              placeholder="Choose price(s)"
                              InputLabelProps={{ shrink: true }}
                              error={!!error.selectedPrices}
                              helperText={error.selectedPrices}
                            />
                          )}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              {...props}
                              sx={{
                                padding: "6px 16px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {option.type === "master" ? (
                                <Typography sx={{ fontWeight: "bold" }}>{option.name}</Typography>
                              ) : (
                                <Typography sx={{ paddingLeft: 3 }}>{option.name}</Typography>
                              )}
                            </Box>
                          )}
                          renderTags={(selected, getTagProps) =>
                            selected.map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={option.name}
                                label={option.name}
                                onDelete={
                                  isLinguistRequestLocked
                                    ? undefined
                                    : () => setSelectedPrices(selected.filter(s => s !== option))
                                }
                              />
                            ))
                          }
                        />
                      </Grid>
                      {/* OK Button */}
                      <Grid item xs={4}>
                        <Btn onClick={handleAddPriceRow} disabled={isLinguistRequestLocked}>
                          OK
                        </Btn>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          )}
          {show && (
            <Box sx={{ mt: 3, mb: 3, mr: 2, textAlign: "right" }}>
              <Btn onClick={handleSave} disabled={isLinguistRequestLocked}>
                {isLinguistSelf
                  ? isLinguistRequestLocked
                    ? "Pending Approval"
                    : "Submit for Approval"
                  : "Save"}
              </Btn>
            </Box>
          )}
        </Box>
      )}
      {!isLinguistSelf && (
        <Box mt={2} mb={2}>
        {/* <Btn onClick={() => setShow(prev => !prev)} disabled={edited === true}> */}
        <Btn
          onClick={() => {
            setShow(prev => {
              const next = !prev;

              if (!prev && freelancerCurrencyCode) {
                setEdit(false);
                setEdited(false);
                setFormData(prevData => ({
                  ...prevData,
                  price_currency: freelancerCurrencyCode, // ✅ RESET HERE
                }));
              }

              return next;
            });
          }}
          disabled={edited === true}
        >
          Create Price List
        </Btn>
      </Box>
      )}
      {/* {!isLinguistSelf && ( */}
      <Box className="whiteBackground" mt={4}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={11}>
            <GenericTable
              columns={columns}
              data={data}
              onEdit={handleEdit}
              onDelete={handleDeleteTable}
              showDelete={!isLinguistSelf}
              displayColumns={4}
              displayRows={data?.length || 5}
            />
          </Grid>
        </Grid>
      </Box>
      {/* )} */}
      {openForDelete && (
        <PopupModal
          maxWidth={"sm"}
          size={"sm"}
          fullWidth={true}
          open={openForDelete}
          handleClose={() => setOpenForDelete(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn
                onClick={() =>
                  dispatch(DeleteClientPriceList(deleteId[1])).then(() => {
                    setFormData({
                      price_name: ``,
                      price_currency: "",
                      min_price_item: "",
                      specialization: [],
                      source_lang: "",
                      target_lang: "",
                      basePriceType: "",
                    });
                    setShow(false);
                    setEdited(false);
                    dispatch(CustomerPriceListing(2));
                    setOpenForDelete(false);
                  })
                }
              >
                Yes
              </Btn>
              <Btn onClick={() => setOpenForDelete(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Delete Price List</Typography>}
        >
          <Typography>Are you sure you want to delete the selected price list ?</Typography>
        </PopupModal>
      )}
      {copyOpen && (
        <PopupModal
          maxWidth={"sm"}
          size={"sm"}
          fullWidth={true}
          open={copyOpen}
          handleClose={() => setCopyOpen(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn onClick={handleCopyPrice}>Copy</Btn>
              <Btn onClick={() => setCopyOpen(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Copy Price record to other Linguist</Typography>}
        >
          <Grid item xs={12} sm={12}>
            <DropdownComponent
              label="Select Option"
              name="client_id"
              value={copyToClient.client_id}
              onChange={handleInputChange}
              options={jobResourceOptions}
              searchable={true}
              isNotMandatory={true}
            />
          </Grid>
        </PopupModal>
      )}
    </Box>
  );
};

export default Step3;
